/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class AVGApiConfig {
  rootUrl: string = 'http://api.nightly.somtoday.build/rest/v1';
}

/**
 * Parameters for `ApiModule.forRoot()`
 */
export interface AVGApiConfigParams {
  rootUrl?: string;
}
